import React from "react";
import eventsJpg from "./images/eventsHeader.jpg";
import ErrorBoundary from "lib/ErrorBoundary";
import { _t } from "app/i18n/i18n";
import { LoadingSpinner } from "lib/Spinner";
import { NotAvailable } from "lib/SimpleTable";
import { ArchiveEventsPanel } from "./parts/ArchiveEventsPanel";
import { Aside } from "lib/Layout";
import { DateFilterControls, LanguageLocationFilterControls, ThemeFilterControls } from "./parts/FilterControls";
import { FutureEventsPanel } from "./parts/FutureEventsPanel";
import useEvents from "lib/hooks/useEvents";
import { features } from "../../app/features";

export const Events = ({ showHeader = true, pastEventDate = "1month" }) => {
  const { isLoading, error, futureEvents, archivedEvents } = useEvents();

  return (
    <ErrorBoundary className="px-2">
      {showHeader && <img className="mb-3 w-100 h-auto" src={eventsJpg} alt="event header" />}

      {isLoading ? (
        <LoadingSpinner />
      ) : error ? (
        <NotAvailable />
      ) : (
        <EventPanels futureEvents={futureEvents} archivedEvents={archivedEvents} pastEventDate={pastEventDate} />
      )}
    </ErrorBoundary>
  );
};

const EventPanels = ({ futureEvents = [], archivedEvents = [], pastEventDate }) => (
  <main>
    <Aside className="mb-3 px-2">
      <h1>{_t("Upcoming Events")}</h1>
      <aside className="d-flex gap">
        {features.eventFilters.showThemeFilters && <ThemeFilterControls/>}
        <LanguageLocationFilterControls/>
      </aside>
    </Aside>
    <FutureEventsPanel events={futureEvents} />

    <Aside className="mb-3 px-2">
      <h1>{_t("Event Replays")}</h1>
      <DateFilterControls pastEventDate={pastEventDate} />
    </Aside>
    <ArchiveEventsPanel events={archivedEvents} />
  </main>
);
